import { CommandProps, Editor } from '@tiptap/core';
import { TextSelection, Transaction } from '@tiptap/pm/state';
import { expandSelectionPositionToIncludeEntireSentence } from '../../utils/expand-selection-to-sentence';

export const expandSelectionToEntireSentence = (
  editor: Editor,
  tr: Transaction,
  initialFrom: number,
  initialTo: number,
) => {
  const { from: updatedFromPosition, to: updatedToPosition } =
    expandSelectionPositionToIncludeEntireSentence(
      editor,
      initialFrom,
      initialTo,
    );

  tr.setSelection(
    TextSelection.create(tr.doc, updatedFromPosition, updatedToPosition),
  );
};
export const expandSelectionToEntireSentenceCommand =
  (initialFrom: number, initialTo: number) =>
  ({ editor, tr }: CommandProps) => {
    expandSelectionToEntireSentence(editor, tr, initialFrom, initialTo);

    return true;
  };
export const getPositionSelectedByUserIfAny = (editor: Editor) => {
  const { from: userSelectedFrom, to: userSelectedTo } = editor.state.selection;
  const isNoTextSelected = userSelectedFrom === userSelectedTo;
  const initialFrom = isNoTextSelected ? 0 : userSelectedFrom;
  const initialTo = isNoTextSelected
    ? editor.state.doc.content.size - 1
    : userSelectedTo;

  return { from: initialFrom, to: initialTo, noTextSelected: isNoTextSelected };
};
